import React, { memo } from "react";
import PropTypes from "prop-types";
import "./style.scss";
function Ellipses({ countEllipses, className }) {
  Ellipses.propTypes = {
    countEllipses: PropTypes.number,
    classPrefix: PropTypes.string,
    className: PropTypes.string,
  };
  const cls = ["ellipse"];
  const ellipses = Array.from({ length: countEllipses }, (_, i) => i + 1);
  return ellipses.map((numberEllipse) => {
    return (
      <div
        key={++numberEllipse}
        className={`${className}-${numberEllipse} ${cls.join(" ")}`}
      />
    );
  });
}

export default memo(Ellipses);
